import { Logger } from '@mntn-dev/logger'

export const i18nLogger = Logger('i18n')
